import{__require as r}from"./global-this.js";var e,t;function i(){if(t)return e;t=1;var i=r(),a=Object.defineProperty;return e=function(r,e){try{a(i,r,{value:e,configurable:!0,writable:!0})}catch(t){i[r]=e}return e}}export{i as __require};
//# sourceMappingURL=define-global-property.js.map
